export default {
    port: 'COM3',

    portOptions: {
        width: 36,
        baudRate: 9600,
        dataBits: '7',
        stopBits: '1',
        parity: 'NONE',
        flowControl: 'XONXOFF',
        rx: {
            width: 36,
        }
    },
};
